import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { buildAbsoluteFileUrl, publicContentApi } from "../api/api";
import "./Home.css";

const Home = () => {
  const [homepageConfig, setHomepageConfig] = useState({
    projectTitle: "خبرخوان",
    homeDescription:
      "این پروژه برای جمع آوری، دسته بندی و مدیریت خبرها طراحی شده است تا تیم شما بتواند منابع خبری را سریع تر رصد کند و گزارش های دقیق تری بسازد.",
    homeLogo: "",
  });

  useEffect(() => {
    let isCancelled = false;
    const fetchHomepageConfig = async () => {
      try {
        const result = await publicContentApi.getHomepageConfig();
        if (!isCancelled) {
          setHomepageConfig({
            projectTitle: String(result?.project_title || "خبرخوان"),
            homeDescription: String(result?.home_description || ""),
            homeLogo: buildAbsoluteFileUrl(result?.home_logo || ""),
          });
        }
      } catch (error) {
        // Keep defaults when endpoint is unreachable.
      }
    };
    fetchHomepageConfig();
    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <main className="home-page">
      <header className="home-header">
        <div className="home-brand">
          {homepageConfig.homeLogo ? (
            <img src={homepageConfig.homeLogo} alt={homepageConfig.projectTitle} className="home-brand-logo" />
          ) : (
            <span className="home-brand-dot" />
          )}
          <strong>{homepageConfig.projectTitle || "خبرخوان"}</strong>
        </div>
      </header>

      <section className="home-card">
        <p className="home-badge">پلتفرم مدیریت و پایش خبر</p>
        <h1 className="home-title">{homepageConfig.projectTitle || "خبرخوان"}</h1>
        <p className="home-description">{homepageConfig.homeDescription}</p>

        <div className="home-stats">
          <article className="home-stat-item">
            <i className="fas fa-rss" />
            <span>پایش پیوسته منابع</span>
          </article>
          <article className="home-stat-item">
            <i className="fas fa-layer-group" />
            <span>دسته بندی هدفمند خبر</span>
          </article>
          <article className="home-stat-item">
            <i className="fas fa-chart-line" />
            <span>گزارش و تحلیل سریع</span>
          </article>
        </div>

        <div className="home-actions">
          <Link to="/login" className="home-button home-button-primary">
            ورود
          </Link>
          <Link to="/terms" className="home-button home-button-secondary">
            قوانین و مقررات
          </Link>
        </div>
      </section>

      <footer className="home-footer">
        <div className="home-footer-links">
          <Link to="/terms">قوانین استفاده</Link>
          <span className="home-footer-sep">|</span>
          <Link to="/login">ورود مدیریت</Link>
        </div>
        <p>© 2026 {homepageConfig.projectTitle || "خبرخوان"} - تمامی حقوق محفوظ است.</p>
      </footer>
    </main>
  );
};

export default Home;
